import { useCallback, useMemo } from 'react';
import { SingleValue } from 'react-select';

import { CountryOption } from '../../types/CountryOption';
import { PhoneCountrySelectOrDisplayProps } from '../../types/PhoneCountrySelectOrDisplayProps';
import { usePhoneCountries } from '../usePhoneCountries';

export const usePhoneCountrySelect = (
  countryCallingCode: PhoneCountrySelectOrDisplayProps['countryCallingCode'],
  onChange: PhoneCountrySelectOrDisplayProps['onChange'],
) => {
  const { countries, defaultCountry } = usePhoneCountries();

  const selectedValue = useMemo(() => {
    const countryNumber = countryCallingCode || defaultCountry?.value;
    if (!countryNumber) {
      return undefined;
    }

    return countries.find((country) => country.value === countryNumber);
  }, [countries, countryCallingCode, defaultCountry?.value]);

  const onCountryChange = useCallback(
    (option: SingleValue<CountryOption>) => {
      if (!option) {
        return;
      }
      onChange(option.value);
    },
    [onChange],
  );

  const countryOptions = useMemo(
    () =>
      countries.map((country) => ({
        value: country.value,
        label: country.label.toString(),
      })),
    [countries],
  );

  return {
    selectedValue,
    countryOptions,
    onCountryChange,
  };
};
